import { IonGrid, IonItem, IonLabel, IonRow } from '@ionic/react'
import React from 'react'
import ImageComponent from '../../../components/image/Image.component'
import { IDocumentAttachment } from '../store/documentScanner.types'
import { PhotoViewer } from '@capacitor-community/photoviewer'
import { IShowPhotoViewerProps } from '../../attachments/page/Attachments.page'

interface IDocumentAttachmentProps {
  document: IDocumentAttachment
}

const DocumentAttachment: React.FC<IDocumentAttachmentProps> = (props: IDocumentAttachmentProps) => {
  const { document } = props

  const showPhotoViewer = (photoViewerProps: IShowPhotoViewerProps) => {
    const { src, alt } = photoViewerProps

    PhotoViewer.show({
      images: [
        {
          url: src || '',
          title: alt,
        },
      ],
      options: {
        share: false,
      },
    })
  }

  return (
    <IonItem data-testid={document.id} key={document.id}>
      <IonGrid className='camera-attachments-grid'>
        <IonRow>
          <ImageComponent
            className='saved-signature'
            isPHI
            src={`data:image/png;base64,${document.imageSource}`}
            alt={document.name}
            onClick={() =>
              showPhotoViewer({ src: `data:image/png;base64,${document.imageSource}`, alt: document.name })
            }
          />
        </IonRow>
        <IonRow className='wrap-text'>
          <IonLabel>{document.name}</IonLabel>
        </IonRow>
      </IonGrid>
    </IonItem>
  )
}

export default DocumentAttachment
